module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/kai-b89619f1467520848521951913c6d022.mp3";